import React, { useEffect, useState } from "react";
import SectionContainer from "../../SectionContainer/SectionContainer";
import "./sectionFive.css";
import { slidesData } from "./slidesData";
//import imageSrc from '/Users/ishaanrajora/WebD/Kalpkriti Website/website/src/images/story-girl-and-snowman.svg'

// eslint-disable-next-line
function isInViewport(element) {
  const rect = element.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}

const SectionFive = () => {
  const [slides] = useState(slidesData);
  const [index, setIndex] = useState(0);

  useEffect(() => {
    // eslint-disable-next-line
    var elem = document.getElementById("sec5");
    //console.log(isInViewport(elem))
    //console.log(elem)
    const lastIndex = slides.length - 1;
    if (index < 0) {
      setIndex(lastIndex);
    }
    if (index > lastIndex) {
      setIndex(0);
    }
  }, [index, slides]);

  useEffect(() => {
    let slider = setInterval(() => {
      setIndex(index + 1);
    }, 4000);
    return () => {
      clearInterval(slider);
    };
  }, [index]);

  return (
    <SectionContainer whiteBG={true}>
      <div className="five-container" id="sec5">
        <div className="five-slide-container">
          {slides.map((slide, slideIndex) => {
            let position = "five-nextSlide";
            if (slideIndex === index) {
              position = "five-activeSlide";
            }
            if (
              slideIndex === index - 1 ||
              (index === 0 && slideIndex === slides.length - 1)
            ) {
              position = "five-lastSlide";
            }

            return (
              <div
                className={"five-slide " + position}
                key={"five" + slideIndex}
              >
                <div className="five-slide-info">
                  <h2>{slide.info1}</h2>
                  <h2>{slide.info2}</h2>
                  <h1>{slide.info3}</h1>
                </div>
                <div className="five-slide-image">
                  <img
                    className="five-slide-img"
                    src={slide.src}
                    alt={"failed to load"}
                  />
                </div>
              </div>
            );
          })}
        </div>
        <div className="five-slider-container">
          {slides.map((slide) => {
            return (
              <div
                key={slide.id}
                className={`${
                  slide.id === index
                    ? "five-slide-current five-slider-pointer"
                    : "five-slider-pointer"
                }`}
                onClick={() => setIndex(slide.id)}
              ></div>
            );
          })}
        </div>
      </div>
    </SectionContainer>
  );
};

export default SectionFive;
